import { axiosInstance } from '.';

const getBranchReviewsList = async (params) => await axiosInstance.get(`/branch_reviews`, { params });

const deleteBranchReview = async ({ id }) => await axiosInstance.delete(`/branch_reviews/${id}`);

const getBranchReviewDetails = async ({ id }) => await axiosInstance.get(`/branch_reviews/${id}`);

export { getBranchReviewsList, deleteBranchReview, getBranchReviewDetails };
